// removed by extract-text-webpack-plugin
module.exports = {"text":"_1m9pn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/components/Checkbox/Checkbox.scss
// module id = 1902
// module chunks = 0